import React, { useState } from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';



const TrailSelector = ({ onTrailSelect, selectedTrail, trails = [] }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('grid');

  const filteredTrails = trails?.filter((trail) =>
  trail?.title?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
  trail?.description?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
  trail?.classroom?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
  trail?.subject?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  return (
    <div className="bg-card rounded-lg shadow-sm p-4 md:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">
          Select Learning Trail
        </h3>
        <div className="flex items-center space-x-2">
          <button
            onClick={() => setViewMode('grid')}
            className={`p-2 rounded-md transition-organic ${
              viewMode === 'grid' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:bg-muted'
            }`}
            aria-label="Grid view"
          >
            <Icon name="Grid" size={18} />
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`p-2 rounded-md transition-organic ${
              viewMode === 'list' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:bg-muted'
            }`}
            aria-label="List view"
          >
            <Icon name="List" size={18} />
          </button>
        </div>
      </div>

      <div className="relative mb-4">
        <Icon
          name="Search"
          size={18}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground"
        />
        <input
          type="text"
          placeholder="Search learning trails..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e?.target?.value)}
          className="w-full pl-10 pr-4 py-2 border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary bg-background text-foreground"
        />
      </div>

      <div className={`${
        viewMode === 'grid' ?'grid grid-cols-1 gap-4' :'space-y-3'
      } max-h-96 overflow-y-auto`}>
        {filteredTrails?.length > 0 ? (
          filteredTrails?.map((trail) => (
            <div
              key={trail?.id}
              onClick={() => onTrailSelect(trail)}
              className={`bg-background border-2 rounded-lg overflow-hidden cursor-pointer transition-organic hover-lift active-press ${
                selectedTrail?.id === trail?.id
                  ? 'border-primary shadow-lg'
                  : 'border-border hover:border-primary/50'
              }`}
            >
              {viewMode === 'grid' ? (
                <>
                  <div className="relative h-40 md:h-48 overflow-hidden">
                    <Image
                      src={trail?.image}
                      alt={trail?.imageAlt}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-2 right-2 px-2 py-1 bg-success text-success-foreground text-xs font-medium rounded">
                      {trail?.status}
                    </div>
                  </div>
                  <div className="p-4">
                    <h3 className="text-base md:text-lg font-semibold text-foreground mb-2 line-clamp-2">
                      {trail?.title}
                    </h3>
                    <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                      {trail?.description}
                    </p>
                    <div className="flex items-center justify-between text-xs text-muted-foreground mb-3">
                      <div className="flex items-center">
                        <Icon name="GraduationCap" size={14} className="mr-1" />
                        <span>Min: {trail?.minGradeLevel || 'All Grades'}</span>
                      </div>
                      <div className="flex items-center">
                        <Icon name="BookOpen" size={14} className="mr-1" />
                        <span>{trail?.subject}</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between pt-3 border-t border-border">
                      <div className="text-xs">
                        <span className="text-muted-foreground">Students: </span>
                        <span className="font-medium text-foreground">{trail?.studentsAssigned}</span>
                      </div>
                      <div className="text-xs">
                        <span className="text-muted-foreground">Completion: </span>
                        <span className="font-medium text-success">{trail?.completionRate}%</span>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <div className="flex gap-4 p-4">
                  <div className="relative w-24 h-24 md:w-32 md:h-32 flex-shrink-0 overflow-hidden rounded-md">
                    <Image
                      src={trail?.image}
                      alt={trail?.imageAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between gap-2 mb-2">
                      <h3 className="text-base md:text-lg font-semibold text-foreground line-clamp-1">
                        {trail?.title}
                      </h3>
                      <div className="px-2 py-1 bg-success text-success-foreground text-xs font-medium rounded flex-shrink-0">
                        {trail?.status}
                      </div>
                    </div>
                    <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
                      {trail?.description}
                    </p>
                    <div className="flex flex-wrap items-center gap-4 text-xs text-muted-foreground">
                      <div className="flex items-center">
                        <Icon name="GraduationCap" size={14} className="mr-1" />
                        <span>Min: {trail?.minGradeLevel || 'All Grades'}</span>
                      </div>
                      <div className="flex items-center">
                        <Icon name="BookOpen" size={14} className="mr-1" />
                        <span>{trail?.subject}</span>
                      </div>
                      <div>
                        <span className="text-muted-foreground">Students: </span>
                        <span className="font-medium text-foreground">{trail?.studentsAssigned}</span>
                      </div>
                      <div>
                        <span className="text-muted-foreground">Completion: </span>
                        <span className="font-medium text-success">{trail?.completionRate}%</span>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="text-center py-12 md:py-16">
            <div className="w-16 h-16 md:w-20 md:h-20 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
              <Icon name="Search" size={32} className="text-muted-foreground" />
            </div>
            <h3 className="text-base md:text-lg font-semibold text-foreground mb-2">
              No trails found
            </h3>
            <p className="text-sm text-muted-foreground">
              Try adjusting your search criteria
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TrailSelector;